import { useQuery } from "react-query";
import { FEATURE_REQUEST_CATEGORIES } from "../constants/featureRequests";
import { apiService } from "../services/api";

export interface FeatureRequestTopic {
  slug: string;
  label: string;
  color: string;
  inUse: number;
  ownerEmail: string;
  teamId: string | null;
  teamName: string;
  canEdit: boolean;
}

// The built-in list keeps the picker and filters working if the topics
// endpoint is unavailable.
const FALLBACK_TOPICS: FeatureRequestTopic[] = FEATURE_REQUEST_CATEGORIES.map(
  (c) => ({
    slug: c.value,
    label: c.label,
    color: "",
    inUse: 0,
    ownerEmail: "",
    teamId: null,
    teamName: "",
    canEdit: false,
  }),
);

export function useFeatureRequestTopics() {
  const query = useQuery<FeatureRequestTopic[]>(
    "feature-request-topics",
    async () => {
      const res = await apiService.getFeatureRequestTopics();
      return (res.data?.data?.items ?? []) as FeatureRequestTopic[];
    },
    { staleTime: 60_000 },
  );

  const topics =
    query.data && query.data.length > 0 ? query.data : FALLBACK_TOPICS;

  const topicLabel = (slug: string): string =>
    topics.find((t) => t.slug === slug)?.label ?? slug;

  return { ...query, topics, topicLabel };
}
